import { PageHeaderSimple, PageLayout } from 'components'

import { APP_PATHS } from '__constants__/paths'
import { CheckoutSessionError } from 'modules/stripe-module/domains/Checkout/components'
import { useNavigate } from 'react-router-dom'

const StripeCheckoutSuccessPage = () => {
  const navigate = useNavigate()

  const onBack = () => navigate(APP_PATHS.DASHBOARD)

  return (
    <PageLayout topHeader={<PageHeaderSimple onlyLogo onBack={onBack} />}>
      <CheckoutSessionError />
    </PageLayout>
  )
}

export default StripeCheckoutSuccessPage
